enum ChipSizeEnum {
    XXL = "h1",
    XL = "h2",
    L = "h3",
    M = "h4",
    S = "h5",
    XS = "h6",
}

export default ChipSizeEnum;
